import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  content: string;
}
export const TestimonialCard: React.FC<TestimonialProps> = ({
  name,
  role,
  location,
  content
}) => {
  return <div className="bg-white p-6 rounded-2xl shadow-md border border-orange-100 flex flex-col h-full relative" data-id="element-91">
      <Quote className="absolute top-4 right-4 text-orange-100 h-8 w-8" data-id="element-92" />
      <div className="flex mb-4" data-id="element-93">
        {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-94" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-95">"{content}"</p>
      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-96">
        <p className="font-bold text-gray-900" data-id="element-97">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-98">{role}</p>
        <p className="text-xs text-orange-600 font-medium" data-id="element-99">{location}</p>
      </div>
    </div>;
};